import _get from 'lodash/get';
import { authorizedFetch } from 'actions/fetch-helper';
import geoEndpoints from 'actions/geo-endpoints';
import WorkSVG from 'public/images/saved-poi-work-icon.svg';
import BookmarkSVG from 'public/images/saved-poi-bookmark-icon.svg';
import HomeSVG from 'public/images/saved-poi-home-icon.svg';

const { v3FavoritesPOIsEndpoint, v3PredictPOIsEndpoint } = geoEndpoints;

export const fetchV3FavoritesPOIs = ({
  latitude,
  longitude,
  isPax,
  company,
}) => {
  const companyID = isPax ? null : _get(company, 'id');
  return authorizedFetch(
    v3FavoritesPOIsEndpoint({ latitude, longitude }),
    companyID,
    true,
  );
};

export const fetchV3PredictPOIs = ({
  latitude,
  longitude,
  pickupOrDropoff,
  isToggle,
  isPax,
  company,
}) => {
  const companyID = isPax ? null : _get(company, 'id');
  return authorizedFetch(
    v3PredictPOIsEndpoint({ latitude, longitude, pickupOrDropoff, isToggle }),
    companyID,
    true,
  );
};

export const labelAndIcon = savedPoi => {
  const label =
    _get(savedPoi, 'label') === undefined
      ? _get(savedPoi, ['address', 'name'])
      : _get(savedPoi, 'label');
  if (label === 'HOME_TAG_PRESET') {
    return { icon: HomeSVG, label: 'Home' };
  }
  if (label === 'WORK_TAG_PRESET') {
    return { icon: WorkSVG, label: 'Work' };
  }
  return { icon: BookmarkSVG, label };
};

export default {};
